import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import Toast from '@hooks/web/public/toast.tsx';
import '@styles/appweb.scss';
import { StageDefault } from '@/context.ts';
import { fetch, GetStageRsp } from '@/fetch.ts';
import header from '@images/web/header.png';
import footer from '@images/web/footer.png';
import Tab1 from '@hooks/web/tab1/index.tsx';
import Tab2 from '@hooks/web/tab2/index.tsx';
import Tab3 from '@hooks/web/tab3/index.tsx';

import { getURLParam } from '@/utils/func.ts';

/* 引入头图一级 */
// const Images = ['header', 'footer', '1', '1-1', '2', '2-1', '3', '3-1', '4', '4-1'].map((item: any) => require(`./assets/images/web/${item}.png`));
// const images = [];
// for (let i = 0; i < Images.length; i++) {
//   images[i] = new Image();
//   images[i].src = Images[i].default;
// }
const { useState, useEffect } = React;
interface StyleType {
  width: string,
  height: string,
}
interface TabType {
  tabName: string,
  tabCurrent: number,

}
/* 配置tab */
const tabs: TabType[] = [
  {
    tabName: 'tab-1',
    tabCurrent: 1,
  },
  {
    tabName: 'tab-2',
    tabCurrent: 2,
  },
  {
    tabName: 'tab-3',
    tabCurrent: 0,
  },
];
const AppWeb: React.FC = () => {
  /* 防抖 */
  const debounce = (wait: number) => {
    let timer: any = null;
    return function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        HeadStyle(styleCompute(960));
        FootStyle(styleCompute(553));
      }, wait);
    }
  }
  const styleCompute: (size: number) => StyleType = size => {
    let styleOutput: StyleType;
    styleOutput = {
      width: `${document.body.offsetWidth > 1300 ? document.body.offsetWidth - 10 : 1300}px`,
      height: `${((document.body.offsetWidth > 1300 ? document.body.offsetWidth : 1300) * size) / 1920}px`,
    }
    return styleOutput;
  }
  const [headStyle, HeadStyle] = useState<StyleType>(styleCompute(960));
  const [footStyle, FootStyle] = useState<StyleType>(styleCompute(553));
  useEffect(() => {
    window.onresize = debounce(500);
  }, [])

  /* tab状态 */
  const [tabList] = useState<TabType[]>(tabs);
  const [tabCurrent, TabCurrent] = useState<number>(0);
  const [iStage, IStage] = useState<number>(0);
  useEffect(() => {
    // console.log = () => null;
    // return;
    /* 获取赛程阶段 */
    fetch.getStage(
      {
        lPid: 0,
        iActId: 20201115,
      },
    ).then((rsp: GetStageRsp) => {
      console.log('赛程阶段', rsp);
      if (rsp.iStage > 0) {
        IStage(rsp.iStage);
        TabCurrent(rsp.iStage >= 4 ? 1 : 2);
        if (getURLParam('web-pkRank') === '1') {
          location.href = "#web-pkRank"; 
        }
      }
    })
  }, [])

  /* toast开关 */
  const [showTabToast, ShowTabToast] = useState<string>('');
  const tabToastOpen: (text: string) => void = text => {
    ShowTabToast(text);
    setTimeout(() => {
      ShowTabToast('');
    }, 3000)
  }

  return (
    <div id="appweb">
      { showTabToast !== '' && <Toast text={showTabToast} />}
      <section className='app_bg'>
        { /* 页面头图 */}
        {/* <img
          className='head_cover'
          src={header}
          alt='头图'
          style={headStyle}
        /> */}
        <video
          className={'head_cover'}
          src={'https://diy-assets.msstatic.com/hyys/activity/20201111effect1.mp4'}
          autoPlay={true}
          muted={true}
          loop={true}
          style={headStyle}
          poster={header}
        />
        <div className='app_content'>
          { /* 页面tab切换逻辑 */}
          <ul className='tabs'>
            {
              tabList.map((item: TabType) => (
                <li
                  className={item.tabName + `${tabCurrent === item.tabCurrent ? '-1' : ''}`}
                  key={item.tabName}
                  onClick={
                    (): void => {
                      if (iStage === 0 && item.tabCurrent !== 0) {
                        tabToastOpen('该活动尚未开启~');
                        return;
                      }
                      TabCurrent(item.tabCurrent);
                    }
                  }
                ></li>
              ))
            }
          </ul>
          <StageDefault.Provider
            value={
              {
                iStage,
                tabToastOpen,
              }
            }
          >
            {
              /*
                这里根据iStage展示不同组件
              */
              [Tab3, Tab1, Tab2].map((item: any, index: number): any => {
                if (index === tabCurrent) {
                  const COMP = item;
                  return <COMP key={index} index={tabCurrent} />
                }
              })
            }
          </StageDefault.Provider>
        </div>
        { /* 页面底部背景 */}
        <img
          className='foot_cover'
          alt='底部背景'
          src={footer}
          style={footStyle}
        />
      </section>
    </div>
  )
}

// 开启 webpack 的 HMR
export default hot(AppWeb);
